let renderEpoch = 0;

export function incrementRenderEpoch(): void {
  renderEpoch += 1;
}

export function nextRenderEpoch(): number {
  renderEpoch += 1;
  return renderEpoch;
}

export function getRenderEpoch(): number {
  return renderEpoch;
}
